export const certificateConstants = {
  GET_CERT_LIST_SUCCESS: 'GET_CERT_LIST_SUCCESS',
  GET_CERT_LIST_FALIURE: 'GET_CERT_LIST_FALIURE',

  GET_CERT_DETAILS_SUCCESS: 'GET_CERT_DETAILS_SUCCESS',
  GET_CERT_DETAILS_FALIURE: 'GET_CERT_DETAILS_FALIURE'
};
